var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.getters.menu)?_c('article',{class:_vm.visible,style:(_vm.styleOption),attrs:{"id":"menu"}},[_c('ul',_vm._l((_vm.menuItemList),function(item){return _c('li',{key:item.value,class:{hrw: item.line},on:{"click":function($event){return _vm.onSelected(item)}}},[_vm._v("\n      "+_vm._s(item.text)+"\n    ")])}),0)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a8a92d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Umenu.vue
// module id = null
// module chunks = 